import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { TdMediaService } from '../services/media.service';
export class TdMediaToggleDirective implements OnInit, OnDestroy {
private _subscription: Subscription;
private _query: string;
private _matches: boolean = false;
private _attributes: {[key: string]: string} = {};
private _styles: {[key: string]: string} = {};
private _classes: string[] = [];
/**
 * tdMediaToggle: string
 * Media query used to evaluate screen/window size.
 * Toggles attributes, classes and styles if media query is matched.
 * @param {?} query
 * @return {?}
 */
set query(query: string) {
    if (!query) {
      throw new Error('Query needed for [tdMediaToggle] directive.');
    }
    this._query = query;
  }
/**
 * mediaAttributes: {[key: string]: string}
 * Attributes to be toggled when media query matches.
 * @param {?} attributes
 * @return {?}
 */
set attributes(attributes: any) {
    this._attributes = attributes;
  }
/**
 * mediaClasses: string[]
 * CSS Classes to be toggled when media query matches.
 * @param {?} classes
 * @return {?}
 */
set classes(classes: string[]) {
    this._classes = classes;
  }
/**
 * mediaStyles: {[key: string]: string}
 * CSS Styles to be toggled when media query matches.
 * @param {?} styles
 * @return {?}
 */
set styles(styles: any) {
    this._styles = styles;
  }
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} _mediaService
 */
constructor(private _renderer: Renderer2,
private _elementRef: ElementRef,
private _mediaService: TdMediaService) { }
/**
 * @return {?}
 */
ngOnInit(): void {
    this._mediaChange(this._mediaService.query(this._query));
    this._subscription = this._mediaService.registerQuery(this._query).subscribe((matches: boolean) => {
      this._mediaChange(matches);
    });
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
/**
 * @param {?} matches
 * @return {?}
 */
private _mediaChange(matches: boolean): void {
    this._matches = matches;
    this._changeAttributes();
    this._changeClasses();
    this._changeStyles();
  }
/**
 * @return {?}
 */
private _changeAttributes(): void {
    for (let /** @type {?} */ attr in this._attributes) {
      this._renderer.setAttribute(this._elementRef.nativeElement, attr,
                                         this._matches ? this._attributes[attr] : undefined);
    }
  }
/**
 * @return {?}
 */
private _changeClasses(): void {
    this._classes.forEach((className: string) => {
      if (this._matches) {
        this._renderer.addClass(this._elementRef.nativeElement, className);
      } else {
        this._renderer.removeClass(this._elementRef.nativeElement, className);
      }
    });
  }
/**
 * @return {?}
 */
private _changeStyles(): void {
    for (let /** @type {?} */ style in this._styles) {
      this._renderer.setStyle(this._elementRef.nativeElement, style,
                                         this._matches ? this._styles[style] : undefined);
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[tdMediaToggle]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
{type: TdMediaService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'query': [{ type: Input, args: ['tdMediaToggle', ] },],
'attributes': [{ type: Input, args: ['mediaAttributes', ] },],
'classes': [{ type: Input, args: ['mediaClasses', ] },],
'styles': [{ type: Input, args: ['mediaStyles', ] },],
};
}

function TdMediaToggleDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdMediaToggleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdMediaToggleDirective.ctorParameters;
/** @type {?} */
TdMediaToggleDirective.propDecorators;
/** @type {?} */
TdMediaToggleDirective.prototype._subscription;
/** @type {?} */
TdMediaToggleDirective.prototype._query;
/** @type {?} */
TdMediaToggleDirective.prototype._matches;
/** @type {?} */
TdMediaToggleDirective.prototype._attributes;
/** @type {?} */
TdMediaToggleDirective.prototype._styles;
/** @type {?} */
TdMediaToggleDirective.prototype._classes;
/** @type {?} */
TdMediaToggleDirective.prototype._renderer;
/** @type {?} */
TdMediaToggleDirective.prototype._elementRef;
/** @type {?} */
TdMediaToggleDirective.prototype._mediaService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
